export default {
  jolsen: {
    name: 'Jacob',
    emailAddress: 'jacob@queenslandrunning.com.au',
    phoneNumber: '+61481297123'
  },
};
